export const hasNonExtendedASCIIChars = (stringToCheck: string): boolean => !/^[\u0020-\u00ff]*$/.test(stringToCheck);
